import React from 'react'
import {
	InputWrapper,
	Label,
	InputContainer,
	StyledInput,
	InputIconLeft,
	InputIconRight,
	ErrorMessage,
	HelperText,
	TextAreaContent
} from './styled'

const Input = ({
	width,
	height,
	maxWidth,
	minWidth,
	label,
	error,
	helperText,
	type = 'text',
	placeholder,
	value,
	onChange,
	isTextArea = false,
	disabled = false,
	required = false,
	id,
	name,
	marginBottom,
	fullWidth = false,
	startAdornment,
	endAdornment,
	icon,
	iconPosition = 'left',
	...props
}) => {
	const inputId = id || name || `input-${Math.random()}`

	const hasCompatIcon = !!icon
	const leftNode =
		startAdornment != null ? startAdornment : (hasCompatIcon && iconPosition === 'left' ? icon : null)
	const rightNode =
		endAdornment != null ? endAdornment : (hasCompatIcon && iconPosition === 'right' ? icon : null)

	const hasLeft = !!leftNode
	const hasRight = !!rightNode
	const hasRightControl = hasRight || (!isTextArea)

	return (
		<InputWrapper $mb={marginBottom} fullWidth={fullWidth}>
			{label && (
				<Label htmlFor={inputId}>
					{label}
					{required && <span className="req">*</span>}
				</Label>
			)}
			<InputContainer width={width} maxWidth={maxWidth} minWidth={minWidth}>
				{hasLeft && (
					<InputIconLeft>{typeof leftNode === 'function' ? leftNode() : leftNode}</InputIconLeft>
				)}
				{!isTextArea ? (
					<>
						<StyledInput
							width={width}
							height={height}
							maxWidth={maxWidth}
							minWidth={minWidth}
							id={inputId}
							name={name}
							type={'text'}
							placeholder={placeholder}
							value={value}
							onChange={onChange}
							disabled={disabled}
							$error={!!error}
							$hasLeft={hasLeft}
							$hasRight={hasRightControl}
							style={fullWidth ? { maxWidth: '100%' } : {}}
							{...props}
						/>
			
					</>
				) : (
					<TextAreaContent
						width={width}
						height={height}
						maxWidth={maxWidth}
						minWidth={minWidth}
						id={inputId}
						name={name}
						type={type}
						placeholder={placeholder}
						value={value}
						onChange={onChange}
						disabled={disabled}
						$error={!!error}
						$hasLeft={hasLeft}
						$hasRight={hasRightControl}
						style={fullWidth ? { maxWidth: '100%' } : {}}
						{...props}
					/>
				)}
				{hasRight && (
					<InputIconRight>
						{typeof rightNode === 'function' ? rightNode() : rightNode}
					</InputIconRight>
				)}
			</InputContainer>
			{error ? (
				<ErrorMessage>{error}</ErrorMessage>
			) : helperText ? (
				<HelperText>{helperText}</HelperText>
			) : null}
		</InputWrapper>
	)
}

export default Input
